<template>
  <div class="grid min-h-screen w-full">
    <div class="col-span-4 lg:col-span-3 flex flex-col items-center justify-center">
      <div class="text-center">
        <h2 class="font-bold text-6xl">Get started in minutes</h2>
        <p class="mt-6">
            Let's get your account set up. Once done, you can select a billing<br />
            plan that fits your firm and get started with our case management<br />
            intake questionnaires, document generation, and e-signature features.
        </p>
      </div>

      <form @submit.prevent="onSubmit" class="flex flex-col mt-6 w-96">
        <account-step v-if="currentStep === 'account'" :account="account" :emailTaken.sync="emailTaken" />

        <security-step v-if="currentStep === 'security'" :account="account" :password-strength="passwordStrength" :service-and-policy-accepted.sync="acceptedTerms" />

        <button role="button" class="btn btn-info" dusk="create-account-button" :disabled="disableContinueButton"
          :title="continueButtonTitle">
          {{ continueButtonText }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import zxcvbn from 'zxcvbn';
import AccountStep from '../components/AccountStep.vue';
import SecurityStep from '../components/SecurityStep.vue';

export default {
  el: '#create-account-app',

  components: {
    AccountStep,
    SecurityStep
  },

  data: () => ({
    referral: window.LS_REFERRAL,
    acceptedTerms: false,
    emailTaken: false,

    steps: ['account', 'security', 'verify'],
    currentStep: 'account',

    account: {
      name: '',
      plan: window.LS_PLAN.code,
      user: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        passwordConfirmation: ''
      }
    },

    plan: window.LS_PLAN
  }),

  computed: {
    appReason() {
      switch (this.appName) {
        case 'LawSync': return 'to power their practice';
        case 'MumboJumbo': return 'as their e-signature solution';
      }
      return this.appName === 'LawSync' ? 'to power their practice' : 'to manage their firm';
    },
    recaptchaKey() {
      return document.querySelector('input[name=recaptcha_key]').value;
    },
    passwordStrength() {
      return zxcvbn(this.account.user.password);
    },

    disableContinueButton() {
      switch (this.currentStep) {
        case 'account':
          return !this.account.name || !this.account.user.firstName || !this.account.user.lastName || !this.account.user.email || this.emailTaken;
        case 'security':
          return this.passwordStrength.score < 3 || this.account.user.password !== this.account.user.passwordConfirmation;
      }
    },

    continueButtonText() {
      switch (this.currentStep) {
        case 'account':
          return 'Continue';
        case 'security':
          return 'Start free trial';
      }
    },

    continueButtonTitle() {
      switch (this.currentStep) {
        case 'account':
          return 'Enter your firm name and your name';
        case 'security':
          return 'Enter your email and password';
      }
    },
  },

  methods: {
    async onSubmit() {
      switch (this.currentStep) {
        case 'account':
          this.currentStep = 'security';
          break;
        case 'security':
          if (this.$recaptchaLoaded) {
            await this.$recaptchaLoaded();
            await this.createAccount(await this.$recaptcha('login'));
          } else {
            this.createAccount();
          }
          break;
      }
    },

    async createAccount(recaptchaToken = null) {
      try {
        this.creating = true;
        const { account } = this;
        const csrfToken = document.querySelector('input[name=_token]').value;
        await axios.post('/api/create-account', {
          account,
          code: this.referral?.code,
          plan: this.plan.code,
          recaptchaToken
        }, {
          headers: {
            'X-CSRF-TOKEN': csrfToken
          }
        });
        window.location.href = '/firm';
      } catch (e) {
        console.error(e);
      } finally {
        this.creating = false;
        //
      }
    }
  }
};
</script>
